// @flow
import React from 'react';
import Highlighter from 'react-highlight-words';
import {
    ProductNameBox,
    Icon,
    LocaleLink,
    Button,
    Status,
} from '../../../common';
import ItemNumber from '../../../orders/itemNumber/ItemNumber';
import I18n from '../../../../i18n/I18n';
import Helper from '../../../../helper/Helper';
import styles from '../../../orders/orderBox/OrderBox.scss';

const OrderBox = (props: Object) => {
    const {
        data,
        receivedType,
        lang,
        acceptedShow,
        seller,
        history,
        asnType,
        transfersType,
        searchString,
        haveReturnAsn,
        haveParentAsn,
        haveItemNr,
        havRefNr,
        haveStatus,
        barcodeRecvMethod,
    } = props;
    const singleAttr = (title, val) => (
        <div className={styles.eachAttr}>
            <h6 className={styles.attrTitle}>{title}</h6>
            <div className={styles.attrVal}>{val}</div>
        </div>
    );

    const divStyle = {
        fontWeight: '600',
    };

    const splitBarcode =
        data && data.partner_barcode && data.partner_barcode.split(',');

    const barCodes = (
        <div>
            {splitBarcode
                ? splitBarcode.map(item => {
                      return <div style={divStyle}>{item ? item : ''}</div>;
                  })
                : ''}
        </div>
    );

    return (
        <div className={styles.ctr}>
            {!receivedType && !havRefNr ? (
                <div>
                    <div className={styles.flexer}>
                        <div className={styles.statusCtr}>
                            <a
                                target="_blank"
                                href={`${Helper.getAppDomain(
                                    'catalog',
                                )}/${Helper.getLocale()}/catalog/${
                                    data.psku_canonical
                                }`}
                            >
                                <ProductNameBox
                                    hideBadge
                                    data={data}
                                    searchString={searchString}
                                />
                            </a>
                            {data.reject_reason ? (
                                <div className={styles.rejectedReason}>
                                    {I18n.getText('transfers.rejected-reason')}:
                                    <span style={{ fontWeight: '400' }}>
                                        &nbsp;{data.reject_reason}
                                    </span>
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                        <div className={styles.flexerRight}>
                            {acceptedShow &&
                            asnType === 1 &&
                            transfersType === 1 ? (
                                <div className={styles.expected}>
                                    <h6 className={styles.attrTitle}>
                                        {I18n.getText('transfers.expected')}
                                    </h6>
                                    <div className={styles.attrVal}>
                                        <div
                                            className={`${styles.iconStatus} ${
                                                data.is_expected
                                                    ? ''
                                                    : styles.warn
                                            }`}
                                        >
                                            <Icon
                                                name={
                                                    data.is_expected
                                                        ? 'tick'
                                                        : 'close'
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                ''
                            )}
                            {data.status ? (
                                <div className={styles.expected}>
                                    <h6 className={styles.attrTitle}>
                                        {I18n.getText('product-table.status')}
                                    </h6>
                                    <div className={styles.attrVal}>
                                        <div>
                                            <Status status={data.status} />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                    <div className={styles.attrCtr}>
                        {data.partner_sku
                            ? singleAttr(
                                  I18n.getText('product-table.p-sku'),
                                  <Highlighter
                                      highlightClassName={styles.highlight}
                                      searchWords={[searchString]}
                                      autoEscape={true}
                                      textToHighlight={data.partner_sku}
                                  />,
                              )
                            : ''}
                        {data.partner_sku_unique
                            ? singleAttr(
                                  I18n.getText('offer.p-sku-unique'),
                                  <Highlighter
                                      highlightClassName={styles.highlight}
                                      searchWords={[searchString]}
                                      autoEscape={true}
                                      textToHighlight={data.partner_sku_unique}
                                  />,
                              )
                            : ''}

                        {data.partner_barcode && barcodeRecvMethod
                            ? singleAttr(
                                  I18n.getText('transfers.partner-barcode'),
                                  <span>
                                      {data.partner_barcode ? (
                                          barCodes
                                      ) : (
                                          <span>--</span>
                                      )}
                                  </span>,
                              )
                            : ''}
                        {data.sku && !barcodeRecvMethod
                            ? singleAttr(
                                  I18n.getText('product-table.sku'),
                                  <Highlighter
                                      highlightClassName={styles.highlight}
                                      searchWords={[searchString]}
                                      autoEscape={true}
                                      textToHighlight={data.sku}
                                  />,
                              )
                            : ''}
                        {haveItemNr
                            ? singleAttr(
                                  I18n.getText('order-details.item-nr'),
                                  <ItemNumber
                                      itemNr={data.item_nr}
                                      seller={seller}
                                      history={history}
                                      searchString={searchString}
                                  />,
                              )
                            : ''}
                        {data.qty >= 0
                            ? singleAttr(I18n.getText('variants.qty'), data.qty)
                            : ''}
                        {data.qty_expected >= 0
                            ? singleAttr(
                                  I18n.getText('transfers.expected'),
                                  data.qty_expected,
                              )
                            : ''}
                        {data.qty_received >= 0
                            ? singleAttr(
                                  I18n.getText('transfers.received'),
                                  data.qty_received,
                              )
                            : ''}
                        {data.qty_rejected >= 0
                            ? singleAttr(
                                  I18n.getText('transfers.qc-rejected'),
                                  data.qty_rejected,
                              )
                            : ''}
                    </div>
                    <div>
                        {haveReturnAsn ? (
                            <div>
                                {data.return_asn ? (
                                    <LocaleLink
                                        to={`/transfers/rtv/${data.return_asn}`}
                                    >
                                        <Button
                                            variant="dashed"
                                            className={styles.button}
                                        >
                                            {data.return_asn}
                                        </Button>
                                    </LocaleLink>
                                ) : (
                                    ''
                                )}
                            </div>
                        ) : (
                            ''
                        )}
                        {haveParentAsn ? (
                            <div>
                                {data.parent_asn ? (
                                    <LocaleLink
                                        to={`/transfers/asn/${data.parent_asn}`}
                                    >
                                        <Button
                                            variant="dashed"
                                            className={styles.button}
                                        >
                                            {data.parent_asn}
                                        </Button>
                                    </LocaleLink>
                                ) : (
                                    ''
                                )}
                            </div>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
            ) : (
                <div>
                    <div className={styles.flexer}>
                        {data.return_asn || data.parent_asn ? (
                            <LocaleLink
                                to={`/transfers/${
                                    transfersType === 1 ? 'rtv' : 'asn'
                                }/${
                                    transfersType === 1
                                        ? data.return_asn
                                        : data.parent_asn
                                }`}
                            >
                                <Button
                                    variant="dashed"
                                    className={styles.button}
                                >
                                    {I18n.getText(
                                        transfersType === 1
                                            ? 'transfers.return-asn'
                                            : 'transfers.parent-asn',
                                    )}
                                </Button>
                            </LocaleLink>
                        ) : (
                            ''
                        )}
                    </div>
                    <div className={styles.attrCtr}>
                        {singleAttr(
                            I18n.getText('transfers.ref-nr'),
                            data.ref_nr,
                        )}
                        {singleAttr(I18n.getText('variants.qty'), data.qty)}
                    </div>
                </div>
            )}
        </div>
    );
};

export default OrderBox;



// WEBPACK FOOTER //
// ./src/components/transfers/asnTable/asnBox/AsnBox.js